import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { UpdateCompanyNameForm } from './UpdateCompanyNameForm'

export const UpdateCompanyNameCommand = (props: ActionButtonProps) => {
  const translate = useTranslate()

  const { tenantId, companyId } = useHook('routing.company.useCompanyParams')()

  const actions = useHook('mutators.crm.useUpdateCompanyNameActions')({
    tenantId,
    companyId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="legalEntity.UpdateCompanyNameCommandData"
      title={translate('updateCompanyName.button')}
      commandDataForm={UpdateCompanyNameForm}
      {...props}
      submit={submit}
    />
  )
}
